import { ErrorHandler, Injectable } from '@angular/core';
import { ErrorReportingService } from 'core/services/error-reporting.service';

const DYNAMIC_IMPORT_ERROR = 'Failed to fetch dynamically imported module';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private _errorReportingService: ErrorReportingService) {}

  handleError(error: unknown): void {
    const reportableError = this.getReportableError(error);
    const message = reportableError instanceof Error ? reportableError.message : String(reportableError);
    if (message.includes(DYNAMIC_IMPORT_ERROR)) {
      this.reloadPage();
    } else {
      this._errorReportingService.captureRuntimeError(reportableError);
    }
  }

  protected reloadPage(): void {
    window.location.reload();
  }

  private getReportableError(error: unknown): unknown {
    if (!error || typeof error !== 'object') {
      return error;
    }

    return (error as { ngOriginalError?: unknown }).ngOriginalError ?? error;
  }
}
